module.exports = __webpack_public_path__ + "static/media/testimonial_bg.1d3d247e.svg";